import {classList, dataset, listen} from 'nuffjs';

const conf = {
	activeClass: 'active',
	changeViewButtonAttr: 'changeViewButton',
	viewAttr: 'view',
};

class Addresses extends HTMLElement {
	static conf = conf;

	currentElement = null;
	currentButton = null;

	firstConnectedCallback() {
		listen(this, 'click', this.onChangeViewButtonClick.bind(this), {
			selector: dataset.selector(conf.changeViewButtonAttr),
		});
	}

	onChangeViewButtonClick(event, target) {
		this.setView(dataset(target).get(conf.changeViewButtonAttr));
	}

	setView(value) {
		if (!this.currentButton) {
			this.currentButton = this.querySelector(
				classList.selector(conf.activeClass) + dataset.selector(conf.changeViewButtonAttr)
			);
			this.currentElement = this.querySelector(
				classList.selector(conf.activeClass) + dataset.selector(conf.viewAttr)
			);
		}
		classList(this.currentButton).remove(conf.activeClass);
		classList(this.currentElement).remove(conf.activeClass);
		this.currentButton = this.querySelector(dataset.selector(conf.changeViewButtonAttr, value));
		this.currentElement = this.querySelector(dataset.selector(conf.viewAttr, value));
		classList(this.currentButton).add(conf.activeClass);
		classList(this.currentElement).add(conf.activeClass);
	}
}

export {Addresses};
